<script>
import Vue from "vue";
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import TemplateForm from "./forms/email-template-form.vue";
import AddButton from "@/components/buttons/add-button.vue";
import api from "@/helpers/apirest/api";

/**
 * Stores Component
 */
export default {
  components: {
    Layout,
    PageHeader,
    AddButton,
    TemplateForm,
  },
  data() {
    return {
      modalId:'template-form-modal',      
      autorefreshInterval: 5,
      intervalId: null,
      pageHeader:{
        title: "Plantillas de correo",
        breadcrumbs: [
          {
            text: "Plantillas de correo",
            href: "/email-templates",
            active: true
          }
        ],
      },
      templates: [],
      selectedItemId:null, 
      showSelectedItemId:null,
    };
  },
  methods: {
    showEditModal(item) {
      this.selectedItemId = item?.id || null;
      this.$bvModal.show(this.modalId);
    },
    onSuccess(){
      this.loadData();
    },
    async loadData() {
        try {            
            const response = await api.get({
                url:'email-templates',
                params:{
                  with_trashed: 1
                },
                config: {
                    withLoading: true
                }
            });

            const templates = response?.data?.data;

            templates.map(item => {
                item.soft_delete_status = (item?.deleted_at) ? 0 : 1;
            });

            this.templates = templates;
        } catch (error) {
          this.templates = [];
        }
    },
    async deleteTemplate(template){
        const result = await Vue.swal({
          title: "Eliminar plantilla",
          icon: "info",
          html:  `Está seguro que desea eliminar la plantilla: ${template?.name}?<br>La accion no se puede deshacer!`,
          showCloseButton: false,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonText: 'Sí',
          cancelButtonText: 'Cancelar',
        });

        if (result.value) {
          await api.delete({
              url: 'email-templates',
              id: template?.id,
              force: true
          });

          this.loadData();
        }        
    },
    async softDeleteRow(item){
        if(!item?.deleted_at){
            await api.delete({
                url: 'email-templates',
                id: item?.id
            });
        }else{
            await api.post({
                url:`email-templates/${item?.id}/restore`
            });
        }

        this.loadData();
    },
    async sendTestEmail(template) {
        const { value: email } = await Vue.swal({
            title: 'Enviar correo de prueba',
            input: 'email',
            inputLabel: 'Correo electrónico',
            inputPlaceholder: 'Ingrese el correo electrónico de prueba',
            showCancelButton: true,
            confirmButtonText: 'Enviar',
            cancelButtonText: 'Cancelar',
            inputValidator: (value) => {
                if (!value) {
                    return 'Debe ingresar un correo electrónico';
                }
            }
        });

        if (email) {
            try {
                Vue.swal({
                    title: 'Enviando correo de prueba...',
                    text: 'Por favor espere mientras se envía el correo',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    showConfirmButton: false,
                    showCancelButton: false,
                    didOpen: () => {
                        Vue.swal.showLoading();
                    }
                });

                await api.post({
                    url: `email-templates/${template.id}/send-test`,
                    data: { email }
                });

                Vue.swal({
                    title: 'Éxito',
                    text: 'El correo de prueba ha sido enviado correctamente',
                    icon: 'success'
                });
            } catch (error) {
                Vue.swal({
                    title: 'Error',
                    text: 'Ha ocurrido un error al enviar el correo de prueba',
                    icon: 'error'
                });
            }
        }
    },
  },
  mounted() {
    this.loadData();
  },
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="pageHeader?.title" :items="pageHeader?.breadcrumbs" />
    <TemplateForm :modal-id="modalId" :id="selectedItemId" @onSuccess="onSuccess"></TemplateForm>    
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body d-flex justify-content-between">
            <p class="text-muted font-13">Administra tus plantillas de correo para los diferentes procesos.</p>
            <div class="text-right">
              <AddButton @click="showEditModal"></AddButton>
            </div>
          </div>
        </div>
      </div>
      <b-skeleton-wrapper :loading="$store.state.loading.loading" class="col-12">
          <template #loading>
            <div class="row">
              <div class="col-xl-3 col-sm-6" v-for="n in 4" :key="n"> 
                <!-- Simulación de 4 tarjetas -->
                <div class="card h-100">
                  <div class="card-body">
                    <div class="d-flex align-items-center justify-content-end">
                      <!-- Checkbox -->
                      <b-skeleton width="20px" height="20px" class="mr-2"></b-skeleton>
                      <!-- Dropdown -->
                      <b-skeleton width="25px" height="25px"></b-skeleton>
                    </div>
                    <!-- Avatar Placeholder -->
                    <div class="text-center">
                      <div class="d-flex justify-content-center">
                        <b-skeleton width="50px" height="50px" class="rounded-circle"></b-skeleton>
                      </div>
                    </div>
                    <!-- Nombre del template -->
                    <div class="media-body text-center mt-3 d-flex align-items-center justify-content-center">
                      <b-skeleton width="60%"></b-skeleton>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <div class="col-xl-3 col-sm-6 mb-3" v-for="template in templates" :key="template.id">
            <div class="card h-100" :class="{'opacity-5': template?.deleted_at}">
              <div class="card-body">
                <div class="d-flex align-items-center justify-content-end">
                  <b-form-checkbox
                      v-model="template.soft_delete_status"
                      switch class="mb-1"
                      value="1"
                      @change="softDeleteRow(template)"
                  ></b-form-checkbox>
                  <b-dropdown right class="qlk-dropdown-sm" variant="white" size="sm">
                    <template v-slot:button-content>
                      <i class="mdi mdi-dots-vertical m-0 text-muted font-size-20"></i>
                    </template>
                    <b-dropdown-item @click="showEditModal(template)">Editar</b-dropdown-item>
                    <b-dropdown-item @click="sendTestEmail(template)">Enviar correo de prueba</b-dropdown-item>
                    <b-dropdown-item @click="deleteTemplate(template)">Eliminar</b-dropdown-item>
                  </b-dropdown>
                </div>
                <div class="text-center">
                  <div class="text-center d-flex justify-content-center">
                    <div class="avatar-sm mt-2 mb-4 text-center">
                      <span class="avatar-title text-center text-uppercase rounded-circle bg-soft-primary text-primary">
                        {{ template?.name?.charAt(0) + template?.name?.charAt(1) }}
                      </span>
                    </div>
                  </div>
                  <div class="media-body">
                    <h5 class="text-truncate">
                      <a href="#" class="text-dark">{{template?.name}}</a>
                    </h5>            
                  </div>
                </div>
              </div>
            </div>
          </div>
      </b-skeleton-wrapper>
    </div>
  </Layout>
</template>